import styled from "styled-components";

export const Color = styled.div`
  width: 100%;
  height: 40px;
  padding: 5px;
  border-radius: 9px;
  border: 2px #c1c1c1;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  display: inline-block;
  cursor: pointer;
  background: ${(props) => props.color};
`;

export const Cover = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

export const CaptureButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 85px;
  color: white;
  padding: 7px 15px;
  text-align: center;
  border: 0;
  background-color: #00abab;
  cursor: pointer;
  font-weight: 500;
`;

export const Popover = styled.div`
  z-index: 2;
  position: absolute;
`;

export const SaveButton = styled.button`
  background-color: #00abab;
  color: white;
  box-shadow: 0 2px 0 rgba(5, 145, 255, 0.1);
  font-size: 14px;
  height: 32px;
  padding: 4px 15px;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
`;

export const Layout = styled.div`
  width: 100%;
  height: 100%;
  h4 {
    font-weight: 400;
  }
`;
